import React from 'react';
import './Hero.css';
import chiltepin from '../assets/chiltepin.png';
import farmer from '../assets/farmer.png';

const Hero = () => {
  return (
    <section className="hero">
      <div className="hero-content">
        <img src={chiltepin} alt="chiltepin" />
       <div className="hero-title">
          <h1 className="hero-txt">La ciudad sueña,</h1><p className='hero-txt2'>el campo alimenta</p>
        </div>
        <img className="hero-farmer" src={farmer} alt="farmer" />
      </div>
      
      
    </section>
  );
};

export default Hero;